export default "__VITE_ASSET__Ha_QWEfp__"